import { Injectable } from '@angular/core';
import { WebService } from '../web/web.service';
import { Observable } from 'rxjs';
import {
  Filters,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import { Domande } from './informativa-aziendale.service';

@Injectable({
  providedIn: 'root',
})
export class InformativaAziendaleWebService {
  private nomeWs = 'informativa-aziendale';
  private lang = 'it-IT';

  constructor(private webService: WebService) {}

  /**
   * Funzione per selezionare le righe da far vedere nella grid
   * Anche se dovrebbe essere una get, viene fatto il post per passarli dei parametri di visualizzazione
   * @param page pagina
   * @param pageSize record per pagina
   * @param ricerca risultato per ricerca
   * @param filters valori da filtrare
   * @param sortBy sort asc desc
   * @returns lista di righe
   */
  public get(
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ): Observable<any> {
    return this.webService.doPost('/api/v1/lang/' + this.lang + '/' + this.nomeWs + '/list', {
      page,
      pageSize,
      ricerca,
      filters,
      sortBy,
    });
  }
  public getDomande(
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ): Observable<any> {
    return this.webService.doPost(
      '/api/v1/lang/' + this.lang + '/' + this.nomeWs + '/list-domande',
      { page, pageSize, ricerca, filters, sortBy },
    );
  }

  public getBozza(codiceSTDR?: string) {
    return this.webService.doGet(
      '/api/v1/lang/' + this.lang + '/' + this.nomeWs + '/bozza',
      codiceSTDR ? { codStdr: codiceSTDR } : {},
    );
  }

  /**
   * Funzine ws per la creazione del Ambito
   * @param data dati da inserire nel MongoDB
   * @returns chiama la funzione postAmbiti per la creazione Ambito
   */
  public post(data: any): Observable<any> {
    return this.webService.doPost('/api/v1/lang/' + this.lang + '/' + this.nomeWs, data);
  }

  public postDomanda(domanda: any): Observable<any> {
    return this.webService.doPost(
      '/api/v1/lang/' + this.lang + '/' + this.nomeWs + '/create-domanda',
      domanda,
    );
  }

  /**
   * Funzione per eliminare una riga da una lista
   * @param idRiga id della riga da eliminare
   * @returns
   */
  public delete(idRiga: any): Observable<any> {
    return this.webService.doDelete('/api/v1/lang/' + this.lang + '/' + this.nomeWs + '/delete', {
      id: idRiga,
    });
  }
  public deleteDomanda(idRiga: any): Observable<any> {
    return this.webService.doDelete(
      '/api/v1/lang/' + this.lang + '/' + this.nomeWs + '/delete-domanda',
      { id: idRiga },
    );
  }

  /**
   *
   * @param id
   * @param ambito
   * @returns
   */
  public put(id: string, informazioni: any): Observable<any> {
    return this.webService.doPut(
      '/api/v1/lang/' + this.lang + '/' + this.nomeWs + '/aggiorna',
      informazioni,
      {
        id,
      },
    );
  }
  public putDoamanda(id: string, domanda: Domande): Observable<any> {
    return this.webService.doPut(
      '/api/v1/lang/' + this.lang + '/' + this.nomeWs + '/aggiorna-domanda',
      domanda,
      {
        id,
      },
    );
  }

  public putPubblica(id: string): Observable<any> {
    return this.webService.doPut(
      '/api/v1/lang/' + this.lang + '/' + this.nomeWs + '/pubblica',
      {},
      {
        id,
      },
    );
  }

  ///api/v1/compila-informativa/lang/{codiceLingua}/get
  public getInformativaAziendaleEsterna(temporaryToken: string) {
    return this.webService.doGet('/api/v1/compila-informativa/lang/' + this.lang + '/get', {
      temporaryToken,
    });
  }

  public getInformativaAziendaleEsternaVsme(temporaryToken: string) {
    return this.webService.doGet('/api/v1/compila-informativa-vsme/lang/' + this.lang + '/get', {
      temporaryToken,
    });
  }

  ///api/v1/compila-informativa/lang/{codiceLingua}/compila
  public putCompilaInformativaAziendaleEsterna(
    temporaryToken: string,
    informazioni: any,
  ): Observable<any> {
    return this.webService.doPut(
      '/api/v1/compila-informativa/lang/' + this.lang + '/compila',
      informazioni,
      {
        temporaryToken,
      },
    );
  }
  public putCompilaInformativaAziendaleEsternaVsme(
    temporaryToken: string,
    informazioni: any,
  ): Observable<any> {
    return this.webService.doPut(
      '/api/v1/compila-informativa-vsme/lang/' + this.lang + '/compila',
      informazioni,
      {
        temporaryToken,
      },
    );
  }

  public putCompilaInformativaAziendaleEsternaBozza(
    temporaryToken: string,
    informazioni: any,
  ): Observable<any> {
    return this.webService.doPut(
      '/api/v1/compila-informativa/lang/' + this.lang + '/salva-bozza',
      informazioni,
      {
        temporaryToken,
      },
    );
  }

  public putCompilaInformativaAziendaleEsternaBozzaVsme(
    temporaryToken: string,
    informazioni: any,
  ): Observable<any> {
    return this.webService.doPut(
      '/api/v1/compila-informativa-vsme/lang/' + this.lang + '/salva-bozza',
      informazioni,
      {
        temporaryToken,
      },
    );
  }

  public getStdr(idInformativa: string | null, isCreazione: boolean) {
    return this.webService.doGet(
      '/api/v1/lang/' + this.lang + '/' + this.nomeWs + '/' + idInformativa + '/list-stdr',
      { isCreazione },
    );
  }
}
